import { Box } from '@rbilabs/universal-components';

import { getDesignToken } from 'styles/constants';
export const TopSelectionContainer = Box.withConfig({
  _ios: {
    zIndex: 1,
  },
  _web: {
    zIndex: 1,
  },
});

export const SearchBarWrapper = Box.withConfig({
  paddingX: { base: '$4', md: 0 },
  marginTop: '$4',
  marginBottom: '$0',
  width: 'full',
  height: getDesignToken('height-input'),
});

export const SearchContainer = Box.withConfig({
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});
